import { Component, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LEAD_BASED_PAINT } from '@shared/utils/app-static-data';
import { AddFirmApplicationDeficiencyComponent } from 'app/components/application/firm/add-firm-application/add-firm-application-deficiency/add-firm-application-deficiency.component';
import { IPersonApplication } from 'app/models/People/person-application';
import { IPersonApplicationDeficiency } from 'app/models/People/person-application-deficiency';
import { PersonService } from 'app/services/person/person.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-individual-application-deficiency',
  templateUrl: './add-individual-application-deficiency.component.html',
  styleUrls: ['./add-individual-application-deficiency.component.scss']
})
export class AddIndividualApplicationDeficiencyComponent {
  public loading: boolean = true;
  public deficiencyForm: FormGroup = null;
  public postErrorMessages: string = "";  
  public formFields = {
    description:{name: 'Deficiency Description', type: 'text'},
    isResolved:{name: 'Deficiency Resolved?', type: 'boolean'},
  };
  public deficiency: IPersonApplicationDeficiency = {
    id: 0,
    personApplication: null,
    applicationId: 0,
    description: '',
    isResolved: false,
  };
  objectKeys = Object.keys;
  public uiData = LEAD_BASED_PAINT;
  
  constructor(
    private readonly toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: {deficiency: IPersonApplicationDeficiency, personApplication: IPersonApplication},
    private readonly dialogRef: MatDialogRef<AddFirmApplicationDeficiencyComponent>,
    public personService: PersonService,
  ) 
  {    
    this.setFormData();
  }

  onSubmit() {
    if (!this.deficiencyForm.valid) {
      this.postErrorMessages = "Description is required";
      this.toastr.error("Please fix validation errors");
      return;
    }
    
    this.getFormValues();    

    this.personService.savePersonApplicationDeficiency(this.deficiency).subscribe(
      result => {
        this.toastr.success("Deficiency Saved");
        this.dialogRef.close(true);    
      },
      error => {
        this.toastr.error("Error saving the deficiency");
        console.error("There was an error saving the deficiency: ", error);
      }
    )
  }

  getFormValues(){
    for (const controlName in this.deficiency) {
      if (this.deficiencyForm.controls.hasOwnProperty(controlName)) {
        this.deficiency[controlName] = this.deficiencyForm.controls[controlName].value;        
      } 
    }  
  }

  setFormData() {
    this.deficiency = (this.data.deficiency) ? this.data.deficiency : this.deficiency;
    this.deficiency.personApplication = this.data.personApplication;
    this.deficiency.applicationId = this.data.personApplication.id;
    
    this.deficiencyForm = new FormGroup({});    
    
    for (const key in this.formFields) {        
      this.deficiencyForm.addControl(key, new FormControl('', Validators.required));      
    }

    for (const controlName in this.deficiency) {            
      if (this.deficiencyForm.controls.hasOwnProperty(controlName)) {        
        this.deficiencyForm.controls[controlName].setValue(this.deficiency[controlName]);
      } 
    }

    this.loading = false;
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
